export const AzureAdClientId = 'fe4e6b5d-d97a-4200-bd3f-8c192bc93360';
export const AzureAdTenantId = '7cc1b8c0-297e-4d5f-a6e0-e5f7518d3e4e';